import styled from 'styled-components';
import ArrowRightDetailsOneSvg from './../assets/hotels/details/arrow-right-1.svg';

const ArrowRightDetailsOneIcon = styled(
  ArrowRightDetailsOneSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowRightDetailsOneIcon;
